export const THEME_COLOR_PRESETS = [
  {
    id: "emerald",
    hex: "#10B981",
    nameKey: "layout.appearanceModal.colors.emerald",
    gradient: "linear-gradient(135deg, #10B981 0%, #059669 100%)",
  },
  {
    id: "amber",
    hex: "#F59E0B",
    nameKey: "layout.appearanceModal.colors.amber",
    gradient: "linear-gradient(135deg, #F59E0B 0%, #D97706 100%)",
  },
  {
    id: "violet",
    hex: "#8B5CF6",
    nameKey: "layout.appearanceModal.colors.violet",
    gradient: "linear-gradient(135deg, #8B5CF6 0%, #6D28D9 100%)",
  },
  {
    id: "cyan",
    hex: "#00E5FF",
    nameKey: "layout.appearanceModal.colors.cyan",
    gradient: "linear-gradient(135deg, #00E5FF 0%, #00B4D8 100%)",
  },
  {
    id: "cobalt",
    hex: "#2563EB",
    nameKey: "layout.appearanceModal.colors.cobalt",
    gradient: "linear-gradient(135deg, #2563EB 0%, #1D4ED8 100%)",
  },
  {
    id: "rose",
    hex: "#F43F5E",
    nameKey: "layout.appearanceModal.colors.rose",
    gradient: "linear-gradient(135deg, #F43F5E 0%, #BE123C 100%)",
  },
];
